import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Database } from 'lucide-react';
import './Login.css';
import { validateEmail } from './utils/validation';

const API_ROOT = process.env.NODE_ENV === 'production'
  ? (process.env.REACT_APP_API_URL || '')
  : (process.env.REACT_APP_API_URL || 'http://localhost:5001');
axios.defaults.baseURL = API_ROOT;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailError = validateEmail(email);
    if (emailError) {
      toast.error(emailError);
      return;
    }
    try {
      setLoading(true);
      const res = await axios.post('/api/auth/forgot-password', { email: email.trim() });
      setSent(true);
      toast.success(res.data.message);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Failed to send reset link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <ToastContainer theme="light" position="top-right" autoClose={4000} />
      <header className="topbar login-topbar">
        <h1 className="topbar-brand">
          <Database size={24} />
          <span>Client Management</span>
        </h1>
        <Link to="/login" className="login-nav-back">
          ← Back to sign in
        </Link>
      </header>
      <div className="login-body">
        <form onSubmit={handleSubmit} className="login-card" autoComplete="off">
          <h2 className="login-title">Forgot password</h2>
          <p className="login-subtitle">
            {sent
              ? 'Check your inbox for a reset link. The link expires in 1 hour.'
              : 'Enter the email address linked to your account and we will send reset instructions.'}
          </p>
          {!sent && (
            <>
              <div className="form-group">
                <label className="form-label" htmlFor="email">Email</label>
                <input
                  id="email"
                  className="form-control"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value.trimStart())}
                  placeholder="Enter your email address"
                  autoComplete="email"
                  maxLength={255}
                  required
                />
              </div>
              <div className="login-actions">
                <button type="submit" disabled={loading} className="btn btn-primary">
                  {loading ? 'Sending…' : 'Send reset link'}
                </button>
                <Link to="/login" className="btn btn-secondary login-link-btn">
                  Cancel
                </Link>
              </div>
            </>
          )}
          {sent && (
            <div className="login-actions">
              <Link to="/login" className="btn btn-primary login-link-btn">
                Back to sign in
              </Link>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
